import React, { useState } from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { ShieldCheckIcon, CheckCircle2Icon, ZapIcon } from 'lucide-react';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}
export function PricingSection() {
  const [bump1Selected, setBump1Selected] = useState(false);
  const [bump2Selected, setBump2Selected] = useState(false);
  const getCheckoutUrl = () => {
    if (bump1Selected && bump2Selected) {
      return 'https://checkout.nuvoraplus.online/cart/53346292040048:1';
    }
    if (bump1Selected) {
      return 'https://checkout.nuvoraplus.online/cart/53346361606512:1';
    }
    if (bump2Selected) {
      return 'https://checkout.nuvoraplus.online/cart/53346362524016:1';
    }
    return 'https://checkout.nuvoraplus.online/cart/53229091651952:1';
  };
  const handleCheckoutClick = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Pack Bases del Entrenamiento de Fuerza',
        content_type: 'product',
        value: 19990,
        currency: 'ARS'
      });
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Pack Bases del Entrenamiento de Fuerza',
        value: 19990,
        currency: 'ARS'
      });
    }
  };
  return <section id="pricing" className="py-10 relative overflow-hidden bg-background-dark" data-id="element-172">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/20 rounded-full blur-[150px] pointer-events-none" data-id="element-173" />

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-174">
        <FadeIn className="text-center mb-10" data-id="element-175">
          <h2 className="text-4xl md:text-5xl font-black mb-6 text-white" data-id="element-176">
            Tu{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-177">
              Inversión Profesional
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-178">
            Accedé hoy al Pack Bases del Entrenamiento de Fuerza, con los 2
            bonos estratégicos incluidos sin costo adicional.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-179">
          <div id="pricing-card" className="bg-gradient-to-b from-card-dark to-background-dark border-2 border-primary/50 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(245,158,11,0.15)] relative overflow-hidden" data-id="element-180">
            {/* Decorative ribbon */}
            <div className="absolute top-0 right-0 bg-red-600 text-white font-bold text-[10px] py-1 px-3 rounded-bl-lg shadow-lg uppercase tracking-wider z-10" data-id="element-181">
              🔥 Oferta Limitada
            </div>

            <div className="text-center mb-10" data-id="element-182">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-183">
                Pack Completo Bases del Entrenamiento de Fuerza
              </h3>
              <p className="text-primary font-semibold text-lg mb-4" data-id="element-184">
                Precio Promocional por Tiempo Limitado:
              </p>
              <div className="flex items-center justify-center gap-2 mb-2" data-id="element-185">
                <span className="text-gray-400 line-through text-xl notranslate" translate="no" data-id="element-186">
                  $49.900 ARS
                </span>
                <span className="bg-green-500/20 text-green-500 px-3 py-1 rounded-full text-sm font-bold" data-id="element-187">
                  Ahorrás 60%
                </span>
              </div>
              <div className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary mb-4 whitespace-nowrap notranslate" translate="no" lang="es" data-id="element-188">
                $
                {(19990 + (bump1Selected ? 9000 : 0) + (bump2Selected ? 9000 : 0)).toLocaleString('es-AR')}{' '}
                <span className="text-2xl text-gray-400 font-medium" data-id="element-189">ARS</span>
              </div>
              <p className="text-gray-400 flex items-center justify-center gap-2" data-id="element-190">
                <ZapIcon className="w-5 h-5 text-primary" data-id="element-191" />
                Pago único. Acceso inmediato. Descarga digital. Garantía de 7
                días sin riesgo.
              </p>
            </div>

            <div className="bg-background-dark/50 border border-card-border-dark rounded-2xl p-6 mb-10" data-id="element-192">
              <h4 className="font-bold text-white mb-4" data-id="element-193">Incluye:</h4>
              <ul className="space-y-3" data-id="element-194">
                {['Base Técnica de 140 Ejercicios Analizados', 'Checklists rápidas de ejecución', 'Bono 1: Bases Nutricionales del Desarrollo Muscular', 'Bono 2: La Práctica Profesional del Entrenador Personal'].map((item, index) => <li key={index} className="flex items-center gap-3 text-gray-300" data-id="element-195">
                    <CheckCircle2Icon className="w-5 h-5 text-primary shrink-0" data-id="element-196" />
                    <span data-id="element-197">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div id="pricing-cta" className="flex flex-col items-center gap-6" data-id="element-198">
              <Button fullWidth href={getCheckoutUrl()} className="md:py-6 md:text-2xl max-w-md mx-auto" onClick={handleCheckoutClick} data-id="element-199">
                Acceder al pack ahora
              </Button>
              <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-200">
                <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-201" />
                <span data-id="element-202">Compra segura. Acceso inmediato.</span>
              </div>
            </div>

            {/* Order Bumps */}
            <div className="mt-10 space-y-5" data-id="element-203">
              {/* Order Bump 1 */}
              <div onClick={() => setBump1Selected(!bump1Selected)} className={`
                  bump-shine relative cursor-pointer rounded-2xl p-5 md:p-6 transition-all duration-300
                  border-2
                  ${bump1Selected ? 'bg-amber-50 border-primary shadow-[0_0_20px_rgba(245,158,11,0.15)]' : 'bg-[#FAF8F5] border-primary/40 hover:border-primary/70'}
                `} data-id="element-204">
                <div className="absolute top-0 left-0 bg-primary text-white text-[10px] font-bold uppercase tracking-wider py-1 px-3 rounded-br-lg rounded-tl-2xl z-10" data-id="element-205">
                  ⭐ Altamente Recomendado
                </div>
                <div className="flex flex-col md:flex-row gap-5 items-start mt-4" data-id="element-206">
                  <img src="https://cdn.magicpatterns.com/uploads/aF14bWzUNXtvk3WXsNustB/mock_up_Order_bump_1.png" alt="El Atlas de Selección" className="w-full md:w-36 rounded-lg object-cover shrink-0" data-id="element-207" />
                  <div className="flex-1 min-w-0" data-id="element-208">
                    <div className="flex items-start gap-3 mb-3" data-id="element-209">
                      <div className={`
                        w-5 h-5 rounded border-2 shrink-0 mt-1 flex items-center justify-center transition-all
                        ${bump1Selected ? 'bg-primary border-primary' : 'border-[#D4C9B0] bg-transparent'}
                      `} data-id="element-210">
                        {bump1Selected && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-211">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-212" />
                          </svg>}
                      </div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-gray-900 leading-tight" data-id="element-213">
                        El Atlas de Selección: Matriz de Decisiones Técnicas
                      </h3>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed mb-1 pl-8 font-semibold" data-id="element-214">
                      Agregá el Atlas y elegí el ejercicio correcto en segundos.
                    </p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-3 pl-8" data-id="element-215">
                      Te dice cuál usar según{' '}
                      <strong data-id="element-216">movilidad, objetivo y complejidad</strong>, para
                      planificar sin dudas y armar la progresión perfecta
                      rápido.
                    </p>
                    <p className="font-heading font-bold text-primary text-sm pl-8 notranslate" translate="no" data-id="element-217">
                      SÍ, AGREGAR EL ATLAS POR SOLO $9.000 ARS
                    </p>
                  </div>
                </div>
              </div>

              {/* Order Bump 2 */}
              <div onClick={() => setBump2Selected(!bump2Selected)} className={`
                  bump-shine relative cursor-pointer rounded-2xl p-5 md:p-6 transition-all duration-300
                  border-2
                  ${bump2Selected ? 'bg-amber-50 border-primary shadow-[0_0_20px_rgba(245,158,11,0.15)]' : 'bg-[#FAF8F5] border-primary/40 hover:border-primary/70'}
                `} data-id="element-218">
                <div className="absolute top-0 left-0 bg-primary text-white text-[10px] font-bold uppercase tracking-wider py-1 px-3 rounded-br-lg rounded-tl-2xl z-10" data-id="element-219">
                  ⭐ Altamente Recomendado
                </div>
                <div className="flex flex-col md:flex-row gap-5 items-start mt-4" data-id="element-220">
                  <img src="https://cdn.magicpatterns.com/uploads/w5qQX9zg6vhzHT4p6R1Yxq/mock_up_order_bump_2.png" alt="Protocolos de Comunicación" className="w-full md:w-36 rounded-lg object-cover shrink-0" data-id="element-221" />
                  <div className="flex-1 min-w-0" data-id="element-222">
                    <div className="flex items-start gap-3 mb-3" data-id="element-223">
                      <div className={`
                        w-5 h-5 rounded border-2 shrink-0 mt-1 flex items-center justify-center transition-all
                        ${bump2Selected ? 'bg-primary border-primary' : 'border-[#D4C9B0] bg-transparent'}
                      `} data-id="element-224">
                        {bump2Selected && <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-225">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-226" />
                          </svg>}
                      </div>
                      <h3 className="font-heading text-lg md:text-xl font-bold text-gray-900 leading-tight" data-id="element-227">
                        Protocolos de Comunicación: El Guion del Profesional de
                        Élite
                      </h3>
                    </div>
                    <p className="text-gray-600 text-sm leading-relaxed mb-1 pl-8 font-semibold" data-id="element-228">
                      Agregá los Protocolos y explicá tu criterio con autoridad.
                    </p>
                    <p className="text-gray-600 text-sm leading-relaxed mb-3 pl-8" data-id="element-229">
                      Scripts listos para <strong data-id="element-230">justificar ejercicios</strong>
                      , responder "¿para qué sirve?" sin titubear y{' '}
                      <strong data-id="element-231">corregir con tacto</strong> para que el alumno
                      confíe y valore tu servicio.
                    </p>
                    <p className="font-heading font-bold text-primary text-sm pl-8 notranslate" translate="no" data-id="element-232">
                      SÍ, AGREGAR LOS PROTOCOLOS POR SOLO $9.000 ARS
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Order Summary */}
            <div className="mt-8 pt-6" data-id="element-233">
              <div className="space-y-3" data-id="element-234">
                <div className="flex items-center justify-between text-sm" data-id="element-235">
                  <span className="text-gray-300" data-id="element-236">
                    Pack Bases del Entrenamiento de Fuerza
                  </span>
                  <div className="flex items-center gap-2 notranslate" translate="no" data-id="element-237">
                    <span className="text-gray-500 line-through text-xs" data-id="element-238">
                      $49.900
                    </span>
                    <span className="text-white font-semibold" data-id="element-239">$19.990</span>
                  </div>
                </div>

                {bump1Selected && <div className="flex items-center justify-between text-sm" data-id="element-240">
                    <span className="text-gray-300" data-id="element-241">Atlas de Selección</span>
                    <span className="text-white font-semibold notranslate" translate="no" data-id="element-242">
                      $9.000
                    </span>
                  </div>}

                {bump2Selected && <div className="flex items-center justify-between text-sm" data-id="element-243">
                    <span className="text-gray-300" data-id="element-244">
                      Protocolos de Comunicación
                    </span>
                    <span className="text-white font-semibold notranslate" translate="no" data-id="element-245">
                      $9.000
                    </span>
                  </div>}

                <div className="border-t border-gray-600/40 pt-3 mt-3" data-id="element-246">
                  <div className="flex items-center justify-between text-sm mb-2" data-id="element-247">
                    <span className="text-gray-400 font-medium" data-id="element-248">
                      Valor Total
                    </span>
                    <span className="text-gray-500 line-through notranslate" translate="no" data-id="element-249">
                      $
                      {(49900 + (bump1Selected ? 9000 : 0) + (bump2Selected ? 9000 : 0)).toLocaleString('es-AR')}
                    </span>
                  </div>
                  <div className="flex items-center justify-between" data-id="element-250">
                    <span className="text-white font-heading font-bold text-lg" data-id="element-251">
                      Hoy pagás solo
                    </span>
                    <span className="text-primary font-heading font-black text-2xl notranslate" translate="no" data-id="element-252">
                      $
                      {(19990 + (bump1Selected ? 9000 : 0) + (bump2Selected ? 9000 : 0)).toLocaleString('es-AR')}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
        {/* New section replacing existing button and info */}
        {/* Add new container for the button and info as per instructions */}
        <div className="mt-6 flex flex-col items-center gap-4" data-id="element-253">
          <Button fullWidth href={getCheckoutUrl()} className="md:py-6 md:text-2xl max-w-md mx-auto" onClick={handleCheckoutClick} data-id="element-254">
            Completar mi pedido ahora
          </Button>
          <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-255">
            <ShieldCheckIcon className="w-5 h-5 text-green-500" data-id="element-256" />
            <span data-id="element-257">Compra segura. Acceso inmediato.</span>
          </div>
        </div>
      </div>
    </section>;
}